import React, { useEffect } from 'react';
import { Hero } from '../components/diagnostico/Hero';
import { WhatIsICD } from '../components/diagnostico/WhatIsICD';
import { Dimensions } from '../components/diagnostico/Dimensions';
import { DiagnosticCTA } from '../components/home/DiagnosticCTA';
import { useLocation } from 'react-router-dom';
export function Diagnostico() {
  const location = useLocation();
  // Scroll to top when navigating to this page
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return <div className="w-full" data-id="element-327" data-mp="1j66faa228bye">
      <Hero data-id="element-328" data-mp="1j4vg6njk7sdm" />
      <WhatIsICD data-id="element-329" data-mp="1j7hl0ff2fts5" />
      <Dimensions data-id="element-330" data-mp="1x563xhpkoquk" />
      {/* Reusing the DiagnosticCTA from Home page as it fits perfectly here as the final conversion step */}
      <DiagnosticCTA data-id="element-331" data-mp="1t3b6wpeoczml" />
    </div>;
}